import { apiClient } from '../../services/apiClient';

/** Sentinel route param resolved server-side to the first published exercise. */
export const FIRST_EXERCISE_ID = 'first';

export async function fetchExercise(exerciseId: string) {
  const path = exerciseId === FIRST_EXERCISE_ID ? '/exercises/first' : `/exercises/${exerciseId}`;
  return apiClient(path);
}

export async function submitExercise(exerciseId: string, command?: string, selectedOptionIds?: string[]) {
  const payload = selectedOptionIds
    ? { selectedOptionIds }
    : { submittedCommand: command ?? '' };

  return apiClient(`/exercises/${exerciseId}/submissions`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function fetchSubmission(submissionId: string) {
  return apiClient(`/submissions/${submissionId}`);
}
